import { Avatar, Card, Flex, Group, GroupProps, Stack, Text } from "@mantine/core";
import { PropsWithChildren, ReactNode } from "react";
import useGetColaboradorById from "@/modules/colaboradores/hooks/useGetColaboradorById";
import { DESAFIO_STATUS } from "@/modules/desafio-cronograma/schema";
import useUserStore from "@/modules/users/store";
import { formatDate } from "@/utils/date";
import { extractInitialsFromText } from "@/utils/text";
import { gerarDadosSelect } from "../../utils/gerar-dados-select";

const statusSelectData = gerarDadosSelect(DESAFIO_STATUS);

const Item = ({
  title,
  value,
  children,
  ...groupProperties
}: PropsWithChildren<{ title: string; value: ReactNode } & GroupProps>) => (
  <Group {...groupProperties}>
    {children}
    <Stack gap={0}>
      <Text fz="sm" c="dimmed">
        {title}
      </Text>
      {value}
    </Stack>
  </Group>
);

type ColaboradorInputProperties = {
  empresaId: TEmpresa["id"];
  colaboradorId: TColaborador["id"];
};
// prettier-ignore
const ColaboradorInput = ({ empresaId, colaboradorId }: ColaboradorInputProperties) => {
  const { data: autor } = useGetColaboradorById(empresaId, colaboradorId);

  return (
    <Item title="Autor" value={<Text>{autor?.nome}</Text>} style={{ flex: 1 }}>
      {autor && (
        <Avatar src={autor && autor.image && autor.image.length > 0 ? autor?.image[0]?.path : ""} key={autor.id} alt={autor.nome || autor.email}>
          {extractInitialsFromText(autor.nome || autor.email)}
        </Avatar>
      )
      }
    </Item >
  );
};

const ItemHistorico = ({ movimentacao }: { movimentacao: TMovimentacao }) => {
  const activeEmpresaId = useUserStore((state) => state.activeEmpresaId);
  const statusLabel = statusSelectData.find((data) => data.value === movimentacao.status)?.label;

  return (
    <Card withBorder>
      <Flex direction="column" gap="sm">
        <Group justify="space-between">
          {activeEmpresaId && <ColaboradorInput empresaId={activeEmpresaId} colaboradorId={movimentacao.createdBy} />}
          <Item title="Status" value={statusLabel} style={{ flex: 0.8 }} />
          <Item title="Data da modificação" value={formatDate(movimentacao.createdAt)} style={{ flex: 0.4 }} />
          <Item title="Observação" value={movimentacao.observacoes} style={{ flex: 1.5 }} />
        </Group>
      </Flex>
    </Card>
  );
};

export default ItemHistorico;
